import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import ErrorPage from "./pages/Error";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorPage />,
  },
  { path: "/skill", element: <Navigate to="/#skill" replace /> },
  { path: "/skills", element: <Navigate to="/#skill" replace /> },
  { path: "/articles", element: <Navigate to="/#article" replace /> },
  { path: "/projects", element: <Navigate to="/#portfolio" replace /> },
  { path: "/portfolio", element: <Navigate to="/#portfolio" replace /> },
  { path: "/journey", element: <Navigate to="/#journey" replace /> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);

reportWebVitals();
